import {
  BASE_URL,
  deleteRequest,
  getRequest,
  objectToFormData,
  patchRequest, patchRequestFormData,
  postRequest,
  postRequestFormData,
} from './utilities/http';
import { FAIRS, FLOOR_PLAN } from './utilities/api.urls';
import {IFetchFairsDto} from "../common/interfaces/fairs";
import {toQueryString} from "../utilities/helpers";

export const fetchAllFairs = async (data: IFetchFairsDto) => {
  return await getRequest(FAIRS + '?' + toQueryString(data));
};

export const fetchFair = async (id: number) => {
  return await getRequest(`${FAIRS}/${id}`);
};

export const deleteFair = async (id: number) => {
  return await deleteRequest(`${FAIRS}/${id}`);
};

export const createFair = async (fair: any) => {
  return await postRequest(FAIRS, fair);
};

export const updateFair = async (fair: any) => {
  if (fair.hall) {
    delete fair.hall;
  }

  return await patchRequest(FAIRS, fair);
};

export const createFloorPlan = async (floorPlan: any) => {
  const data = floorPlan.data;
  // @ts-ignore
  delete floorPlan.data;

  const formData = objectToFormData(floorPlan);
  if (data) {
    formData.append('jsonData', data, data.name);
  }

  return await postRequestFormData(FLOOR_PLAN, formData);
};

export const updateFloorPlan = async (floorPlan: any, floorPlanID: number) => {
  const data = floorPlan.data;
  // @ts-ignore
  delete floorPlan.data;

  const formData = objectToFormData(floorPlan);
  if (data) {
    formData.append('jsonData', data, data.name);
  }

  return await patchRequestFormData(FLOOR_PLAN + '/' + floorPlanID, formData);
};

export const publishFair = async (id: number) => {
  return await postRequest(`/fair/${id}/publish`, {});
};

export const exportFloorPlan = async (id: number) => {
  return await fetch(`${BASE_URL}/floor-plan/${id}/export`, {method:'POST'});
};

export const pushFloorPlans = async (fairId: number, halls:number[]) => {
  return await postRequest('/publish-floor-plans', {
    fairID:fairId,
    hallIDs:halls
  });
};
